export default class Print {
  static log = (text: string) => console.log(text);
  static error = (text: string) => console.error(text);
}
